module.exports = __webpack_public_path__ + "img/backbtn.72971b3f.svg";